import { Component, inject, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { CommonModule } from '@angular/common';
import { DynamicFormArray, Props, SECTION_TYPE} from '../../model/form.model';
import { BUTTON_NAMES } from '../../model/common.model';
import { SearchContainerComponent } from '../search-container/search-container.component';
import { DynamicDataTableComponent } from '../dynamic-data-table/dynamic-data-table.component';
import { CamelCasePipe } from '../../utils/camel-case.pipe';
import { CommonUtils } from '../../utils/common.utils';
import { SpinnerComponent } from '../spinner/spinner.component';

@Component({
  selector: 'app-tabs',
  standalone: true,
  imports: [CommonModule, MatTabsModule, SearchContainerComponent, DynamicDataTableComponent,CamelCasePipe,
    SpinnerComponent
  ],
  templateUrl: './tabs.component.html',
  styleUrl: './tabs.component.scss'
})
export class TabsComponent implements OnInit {

  public beginRender = false;
  public selectedIndex = 0;
  @Input() tabConfig!: Array<any>;
  @Input() props!: Props;
  @Input() filterSchema!: DynamicFormArray
  @Input() title!:string;
  @Input() forSection?: boolean = false;
  @Input() isLoading = false;
  @Output() tabChange = new EventEmitter<number>();
  public spinnerName = 'pageContainer';
  private readonly commonUtils = inject(CommonUtils);
  readonly TabType: typeof SECTION_TYPE = SECTION_TYPE;
  ngOnInit(): void {
    this.beginRender = true;
    //this.commonUtils.spinner('show', this.spinnerName)
  }
  onTabChange(event: MatTabChangeEvent) {
    this.selectedIndex = event.index;
    const tab = this.tabConfig[this.selectedIndex];
    if(tab['tabOnChangeSubject']){
      tab['tabOnChangeSubject'].next(BUTTON_NAMES['Reset'])
    }
    this.tabChange.emit(this.selectedIndex);
  }
  ngOnDestory(){
     //this.commonUtils.spinner('hide', this.spinnerName)
  }
}
